<template>
  <div :class="background">
    <div class="px-4 pb-4">
      <h1>{{ $t('RANKING.TITLE') }}</h1>
      <p>{{$t('RANKING.KEEP_PLAYING')}}</p>

      <LeagueToggle v-model="league" />
    </div>

    <BaseLoader v-if="loading" />

    <v-list v-else class="transparent py-0">
      <!-- Previuos users -->
      <v-divider />
      <RankingListItem
        v-for="(user) in users"
        :key="user.id"
        :divider="user.divider"
        :name="user.name"
        :avatar="user.pic"
        :rank="user.rank + ''"
        :own="user.id === id"
      />
    </v-list>
  </div>
</template>

<script>
import LeagueToggle from '@/components/ranking/LeagueToggle.vue';
import RankingListItem from '@/components/ranking/RankingListItem.vue';

const LEAGUES = ['gold', 'silver', 'bronze'];

export default {
  name: 'GlobalRanking',
  components: {
    LeagueToggle,
    RankingListItem,
  },
  props: {
    background: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    league: 1,
    users: [],
  }),
  computed: {
    id() {
      return this.$store.state.session.id;
    },
    loading() {
      return this.$store.state.ranking.loading;
    },
  },
  methods: {
    updateRank() {
      const users = this.$store.state.ranking.list[LEAGUES[this.league]];

      this.users = users;
      const rank = this.getIndex(this.id);

      const userLeague = this.$store.state.ranking.league;
      const tooFar = (rank === -1 && userLeague === LEAGUES[this.league]);

      if (rank <= 7 && !tooFar) {
        this.users = users.slice(0, 7);
        return true;
      }

      const top6 = users.slice(0, 6);

      if (tooFar) {
        this.users = [
          ...top6,
          { divider: true },
          {
            rank: this.$store.state.ranking.rank || users.length,
            name: this.$store.state.session.name,
            pic: this.$store.state.session.pic,
            own: true,
          },
        ];

        return true;
      }

      const top3 = users.slice(0, 3);
      this.users = [
        ...top3,
        { divider: true },
        users[rank - 1],
        users[rank],
      ];

      if (rank < users.length - 1) {
        this.users.push(users[rank + 1]);
      }

      return true;
    },
    getIndex(id) {
      for (let i = 0; i < this.users.length; i += 1) {
        if (this.users[i].id === id) {
          return i;
        }
      }

      return -1;
    },
  },
  created() {
    this.$store.dispatch('ranking/get')
      .then(() => {
        this.league = LEAGUES.indexOf(this.$store.state.ranking.league);
      })
      .then(() => this.updateRank());
  },
  watch: {
    league() {
      this.$store.dispatch('ranking/getLeague', LEAGUES[this.league])
        .then(() => this.updateRank());
    },
  },
};
</script>
